import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { NavigationMenuItem } from '../../types/NavigationMenuItem';
import { Notification } from '../../types/Notification';

export const homeApi = createApi({
  reducerPath: 'homeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: cmsApiConfig.url,
    headers: {
      'X-CSRF': '1',
    },
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    getNavigationMenuItems: builder.query<NavigationMenuItem[], void>({
      query: () => ({
        url: `/start/navigation`,
      }),
    }),
    getNotificationItems: builder.query<Notification[], void>({
      query: () => ({
        url: `/start/notifications`,
      }),
    }),
  }),
});

export const {
  useGetNavigationMenuItemsQuery,
  useLazyGetNavigationMenuItemsQuery,
  useGetNotificationItemsQuery,
  useLazyGetNotificationItemsQuery,
} = homeApi;
